
import React, { useState } from 'react';
import { Calendar as CalendarIcon, Filter, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { addMonths, subMonths, format, addWeeks, subWeeks, addDays, subDays } from 'date-fns';
import CalendarGrid from '@/components/calendar/CalendarGrid';

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState<'month' | 'week' | 'day'>('month');
  const showCampaigns = true;
  const showEvents = true;

  const navigateDate = (direction: 'prev' | 'next') => {
    if (view === 'month') {
      setCurrentDate(prev => direction === 'next' ? addMonths(prev, 1) : subMonths(prev, 1));
    } else if (view === 'week') {
      setCurrentDate(prev => direction === 'next' ? addWeeks(prev, 1) : subWeeks(prev, 1));
    } else {
      setCurrentDate(prev => direction === 'next' ? addDays(prev, 1) : subDays(prev, 1));
    }
  };

  const goToToday = () => {
    setCurrentDate(new Date());
  };

  const getDateTitle = () => {
    if (view === 'month') {
      return format(currentDate, 'MMMM yyyy');
    } else if (view === 'week') {
      return format(currentDate, "'Week of' MMM d, yyyy");
    } else {
      return format(currentDate, 'MMMM d, yyyy');
    }
  };

  return (
    <div className="flex flex-col h-full bg-gray-50/30">
      {/* Header */}
      <div className="shrink-0 bg-white border-b px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <CalendarIcon className="w-6 h-6 text-primary" />
            <h1 className="text-2xl font-semibold text-foreground">Calendar</h1>
          </div>

        </div>
      </div>

      {/* Controls */}
      <div className="shrink-0 bg-white border-b px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-6">
            {/* View Toggle */}
            <div className="flex items-center bg-purple-50 rounded-lg p-1">
              {(['month', 'week', 'day'] as const).map((viewType) => (
                <button
                  key={viewType}
                  onClick={() => setView(viewType)}
                  className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${view === viewType
                    ? 'bg-purple-600 text-white shadow-md'
                    : 'text-purple-700 hover:text-purple-800 hover:bg-purple-100'
                    }`}
                >
                  {viewType.charAt(0).toUpperCase() + viewType.slice(1)}
                </button>
              ))}
            </div>

            {/* Date Navigation */}
            <div className="flex items-center space-x-3">
              <Button
                variant="outline"
                size="sm"
                onClick={goToToday}
                className="shadow-sm font-medium border-purple-200 text-purple-700 hover:bg-purple-50 hover:border-purple-300"
              >
                Today
              </Button>
              <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigateDate('prev')}
                  className="hover:bg-purple-50 text-purple-600 hover:text-purple-700"
                >
                  <ChevronLeft className="w-4 h-4" />
                </Button>
                <span className="font-semibold text-lg min-w-[220px] text-center text-foreground">
                  {getDateTitle()}
                </span>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigateDate('next')}
                  className="hover:bg-purple-50 text-purple-600 hover:text-purple-700"
                >
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>






      {/* Calendar */}
      <div className="flex-1 p-6 overflow-hidden">
        <CalendarGrid
          currentDate={currentDate}
          view={view}
          showCampaigns={showCampaigns}
          showEvents={showEvents}
        />
      </div>
    </div>
  );
};

export default Calendar;
